const APIAction = {
  GET: 'get',
  POST: 'post',
};

export default APIAction;
